import { z } from "zod";

export const setFormSchema = z.object({
    active: z.boolean(),
    title: z.string(),
    subtitle: z.string(),
    /** BE: values?: Array<{ key: string; value: string | number }> */
    fields: z.array(
        z
            .object({
                /** BE key - the output variable name being set */
                key: z.string(),
                /** Full value including any source prefix, e.g. {parsedBody.eid}, {query.name}, {eid} */
                value: z.string().min(1, "components.connection-creator.nodes.set.forms.value_required"),
            })
            .superRefine((val, ctx) => {
                const key = val.key.trim();
                const innerKey = key.replace(/^\{|\}$/g, "").trim();

                if (!key) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.too_small,
                        minimum: 1,
                        type: "string",
                        inclusive: true,
                        path: ["key"],
                        message: "components.connection-creator.nodes.set.forms.key_required",
                    });
                } else if (!/^\{[^{}]+\}$/.test(key) || !innerKey) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        path: ["key"],
                        message: "components.connection-creator.nodes.set.forms.key_invalid",
                    });
                }
            })
    ),
});
